import React from "react";
import styled from "@emotion/styled";
import { Link } from "react-router-dom";

import { responsive } from "../../utils/style";
import { css } from "@emotion/react";

const PortalCard = ({
  color,
  topic,
  description,
  icon,
  full,
  disable,
  resFull,
  isTree,
  link,
}) => (
  <Container
    key={topic}
    color={color}
    full={full}
    resFull={resFull}
    isTree={isTree}
    disable={disable}
    to={link}
  >
    {icon && <Icon src={icon} />}
    <Topic disable={disable}>{topic}</Topic>
    <Description disable={disable}>{description}</Description>
  </Container>
);

const Container = styled(Link)`
  position: relative;
  width: ${(props) =>
    props.full ? "100%" : props.isTree ? "calc(100% / 3 - 4px)" : "451.5px"};
  height: 120px;
  background-color: ${(props) => (props.disable ? "#E7EAEE" : props.color)};

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 8px;

  margin-bottom: 8px;

  cursor: ${(props) => (props.disable ? "not-allowed" : "pointer")};

  ${(props) =>
    responsive.tablet(css`
      width: ${props.full || props.resFull ? "100%" : "calc(100% / 2 - 4px)"};
      height: 100px;
    `)}

  ${(props) =>
    responsive.mobile(css`
      width: ${props.full || props.resFull ? "100%" : "calc(100% / 2 - 4px)"};
      height: ${props.full || props.resFull ? "62px" : "80px"};
    `)}
`;

const Icon = styled.img`
  position: absolute;
  left: 0;
  bottom: 0;

  width: 55px;
`;

const Topic = styled.span`
  font-family: "Noto Sans Thai", "Noto Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 33px;
  line-height: 40px;

  text-align: right;
  letter-spacing: -0.02em;

  color: ${(props) => (props.disable ? "#A0ABBB" : "#ffffff")};

  z-index: 1;

  ${responsive.tablet(css`
    font-size: 28px;
    line-height: 34px;
  `)}

  ${responsive.mobile(css`
    font-size: 18px;
    line-height: 26px;
  `)}
`;

const Description = styled.span`
  font-family: "Noto Sans Thai", "Noto Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 26px;
  line-height: 34px;

  text-align: right;
  letter-spacing: -0.02em;

  color: ${(props) => (props.disable ? "#A0ABBB" : "#ffffff")};

  z-index: 1;

  ${responsive.tablet(css`
    font-size: 20px;
    line-height: 28px;
  `)}

  ${responsive.mobile(css`
    font-size: 16px;
    line-height: 26px;
  `)}
`;

export default PortalCard;
